import './catalogue/publicPath';
// import "./assets/css/vendor/bootstrap.min.css";
import "./assets/css/sass/_style.scss";
import loadClarity from "./utils/clarity";

let render = () => {

  const hideChat = () => {
    window.tidioChatApi.display(false);
  }

  if (window.tidioChatApi) {
    window.tidioChatApi.on("ready", hideChat);
    window.tidioChatApi.on("close", hideChat);
  } else {
    document.addEventListener("tidioChat-ready", hideChat);
  }
  
  // import('./assets/css/sass/themes/gogo.' + color + '.scss').then(x => {
     require('./AppRenderer');
  //});
};

render();
if (!document.getElementById('recs-catalogue') && document.getElementById('recs-legacy-page')?.dataset.analyticsEnabled !== 'false') loadClarity();
